import React from 'react';
import { PropTypes as RPT } from 'prop-types';

class Popup extends React.PureComponent {
  static propTypes = {
    success: RPT.string,
    error: RPT.string,
    visible: RPT.object,
    className: RPT.string,
  }

  constructor(props) {
    super(props);
    this.state = {
      visibility: true,
    };
  }

  close() {
    this.setState({ visibility: false });
  }

  render() {
    const {
      success, error, visible, className,
    } = this.props;
    const { visibility } = this.state;

    if (visible.success) {
      return (
        <div className={className}>
          {success}
        </div>
      );
    }

    if (visible.error && visibility) {
      return (
        <div className={className}>
          <button className="close" onClick={() => this.close()}>
            &times;
          </button>
          {error}
        </div>
      );
    }

    return <div />;
  }
}

export default Popup;
